(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chastar-image-swipe-assets"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.ChastarImageSwipe) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const applySource = (image, next, sizes = image.getAttribute('sizes')) => {
    if (sizes) image.setAttribute('sizes', sizes);
    if (next.srcset) image.setAttribute('srcset', next.srcset);
    else image.removeAttribute('srcset');
    image.setAttribute('src', next.src);
    if (next.alt !== undefined) image.setAttribute('alt', next.alt);
    for (const attribute of ['width', 'height']) {
      if (Number(next[attribute]) > 0) image.setAttribute(attribute, next[attribute]);
    }
  };

  const prepareImage = async (next, sizes, signal) => {
    const image = new Image();
    image.loading = 'eager';
    image.decoding = 'async';
    image.alt = '';
    image.draggable = false;

    const loaded = await new Promise((resolve) => {
      let settled = false;
      const settle = (success) => {
        if (settled) return;
        settled = true;
        clearTimeout(timeout);
        image.removeEventListener('load', onLoad);
        image.removeEventListener('error', onError);
        signal.removeEventListener('abort', onAbort);
        if (!success) {
          image.removeAttribute('srcset');
          image.removeAttribute('src');
        }
        resolve(success);
      };
      const onLoad = () => settle(image.naturalWidth > 0);
      const onError = () => settle(false);
      const onAbort = () => settle(false);
      const timeout = setTimeout(onError, 10000);
      image.addEventListener('load', onLoad);
      image.addEventListener('error', onError);
      signal.addEventListener('abort', onAbort, { once: true });
      if (signal.aborted) {
        settle(false);
        return;
      }
      applySource(image, next, sizes);
      if (image.complete) settle(image.naturalWidth > 0);
    });

    if (!loaded || signal.aborted) return null;
    try {
      if (image.decode) await image.decode();
    } catch {
      if (!image.complete || image.naturalWidth === 0) return null;
    }
    return signal.aborted ? null : image;
  };

  window.ChastarImageSwipe = class {
    constructor(image, options = {}) {
      this.image = image;
      this.viewport = options.viewport || image.parentElement;
      this.index = Number(options.initialIndex) || 0;
      this.key = String(options.initialKey || `${image.getAttribute('src')}|${image.getAttribute('srcset') || ''}`);
      this.duration = Math.max(0, Number(options.duration ?? 320) || 0);
      this.easing = options.easing || 'cubic-bezier(0.22, 0.61, 0.36, 1)';
      this.pending = null;
      this.active = null;
      this.destroyed = false;
    }

    show(next, options = {}) {
      if (this.destroyed || !next?.src || !this.viewport) {
        this.cancel();
        return Promise.resolve(false);
      }
      const key = String(next.key || `${next.src}|${next.srcset || ''}`);
      const index = Number.isFinite(Number(options.index)) ? Number(options.index) : this.index;
      if (this.pending?.key === key && this.pending.index === index) return this.pending.promise;

      this.cancel();
      if (key === this.key) {
        applySource(this.image, next, next.sizes || this.image.getAttribute('sizes'));
        this.index = index;
        return Promise.resolve(true);
      }
      const direction = options.direction === -1 || options.direction === 1
        ? options.direction
        : index < this.index ? -1 : 1;
      const request = { key, index, abort: new AbortController() };
      this.pending = request;
      request.promise = this.run(next, direction, request)
        .catch(() => {
          if (this.pending === request) this.clearStage();
          return false;
        })
        .finally(() => {
          if (this.pending === request) this.pending = null;
        });
      return request.promise;
    }

    async run(next, direction, request) {
      const sizes = next.sizes || this.image.getAttribute('sizes') || `${Math.ceil(this.image.clientWidth || window.innerWidth)}px`;
      const incoming = await prepareImage(next, sizes, request.abort.signal);
      if (!incoming || this.pending !== request || !this.image.isConnected) return false;

      let outgoing = null;
      if (!reducedMotion.matches && this.duration > 0 && this.image.animate && this.image.naturalWidth > 0) {
        outgoing = await prepareImage({ src: this.image.currentSrc || this.image.src }, null, request.abort.signal);
      }
      if (this.pending !== request || request.abort.signal.aborted || !this.image.isConnected) return false;

      const imageRect = this.image.getBoundingClientRect();
      const viewportRect = this.viewport.getBoundingClientRect();
      const animate = outgoing && !reducedMotion.matches && imageRect.width > 0 && imageRect.height > 0;

      if (animate) {
        const style = getComputedStyle(this.image);
        const stage = document.createElement('span');
        stage.className = 'chastar-image-swipe__stage';
        stage.setAttribute('aria-hidden', 'true');
        const frames = [outgoing, incoming].map((image) => {
          const frame = document.createElement('span');
          frame.className = 'chastar-image-swipe__frame';
          Object.assign(frame.style, {
            left: `${imageRect.left - viewportRect.left - this.viewport.clientLeft}px`,
            top: `${imageRect.top - viewportRect.top - this.viewport.clientTop}px`,
            width: `${imageRect.width}px`,
            height: `${imageRect.height}px`
          });
          Object.assign(image.style, { objectFit: style.objectFit, objectPosition: style.objectPosition });
          image.alt = '';
          frame.append(image);
          stage.append(frame);
          return frame;
        });
        frames[1].style.transform = `translateX(${direction * 100}%)`;
        const active = {
          stage,
          animations: [],
          viewportClassAdded: !this.viewport.classList.contains('chastar-image-swipe'),
          positionedClassAdded: getComputedStyle(this.viewport).position === 'static',
          originalClassAdded: !this.image.classList.contains('chastar-image-swipe__original')
        };
        this.active = active;
        this.viewport.classList.add('chastar-image-swipe');
        if (active.positionedClassAdded) this.viewport.classList.add('chastar-image-swipe--positioned');
        this.viewport.append(stage);
        this.image.classList.add('chastar-image-swipe__original');
      }

      applySource(this.image, next, sizes);
      this.key = request.key;
      this.index = request.index;
      if (!animate) return true;

      const active = this.active;
      const frames = active.stage.children;
      const timing = { duration: this.duration, easing: this.easing, fill: 'both' };
      active.animations.push(frames[0].animate([
        { transform: 'translateX(0%)' },
        { transform: `translateX(${-direction * 100}%)` }
      ], timing));
      active.animations.push(frames[1].animate([
        { transform: `translateX(${direction * 100}%)` },
        { transform: 'translateX(0%)' }
      ], timing));
      await Promise.allSettled(active.animations.map((animation) => animation.finished));
      if (this.active === active) this.clearStage();
      return !request.abort.signal.aborted;
    }

    clearStage() {
      const active = this.active;
      if (!active) return;
      this.active = null;
      for (const animation of active.animations) animation.cancel();
      active.stage.remove();
      if (active.originalClassAdded) this.image.classList.remove('chastar-image-swipe__original');
      if (active.viewportClassAdded) this.viewport.classList.remove('chastar-image-swipe');
      if (active.positionedClassAdded) this.viewport.classList.remove('chastar-image-swipe--positioned');
    }

    cancel() {
      this.pending?.abort.abort();
      this.pending = null;
      this.clearStage();
    }

    destroy() {
      this.cancel();
      this.destroyed = true;
    }
  };
})();

if (!customElements.get('chastar-card-swatches')) {
  customElements.define('chastar-card-swatches', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        const swatch = event.target.closest('[data-chastar-swatch]');
        if (!swatch || !this.contains(swatch)) return;
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        const card = this.closest('.product-card-wrapper');
        if (!card) return;
        event.preventDefault();
        event.stopPropagation();

        const image = card.querySelector('.card__media .media > img');
        const selected = this.querySelector('[data-chastar-swatch][aria-current="true"]');
        if (this.swipe && this.swipe.image !== image) {
          this.swipe.destroy();
          this.swipe = null;
        }
        if (!this.swipe && image && window.ChastarImageSwipe) {
          this.swipe = new window.ChastarImageSwipe(image, {
            initialIndex: Number(selected?.dataset.swatchIndex || 0),
            initialKey: selected?.dataset.imageId
          });
        }

        for (const item of this.querySelectorAll('[data-chastar-swatch]')) {
          item.setAttribute('aria-current', item === swatch ? 'true' : 'false');
        }

        if (image && swatch.dataset.imageSrc) {
          card.classList.add('chastar-card-colour-selected');
          const next = {
            key: swatch.dataset.imageId,
            src: swatch.dataset.imageSrc,
            srcset: swatch.dataset.imageSrcset,
            width: swatch.dataset.imageWidth,
            height: swatch.dataset.imageHeight,
            alt: swatch.dataset.imageAlt || swatch.dataset.colourName
          };
          if (this.swipe) {
            this.swipe.show(next, { index: Number(swatch.dataset.swatchIndex) });
          } else {
            if (next.srcset) image.setAttribute('srcset', next.srcset);
            else image.removeAttribute('srcset');
            image.setAttribute('src', next.src);
            image.setAttribute('alt', next.alt);
            image.setAttribute('width', next.width);
            image.setAttribute('height', next.height);
          }
        } else {
          this.swipe?.cancel();
        }

        for (const link of card.querySelectorAll('.card__heading a[href], .card__media a[href]')) {
          const url = new URL(link.href, window.location.href);
          url.searchParams.delete('option_values');
          url.searchParams.set('variant', swatch.dataset.variantId);
          link.href = url.toString();
        }

        const unavailable = swatch.dataset.available === 'false';
        card.querySelectorAll('[data-chastar-stock-badge]').forEach(badge => { badge.hidden = !unavailable; });
        card.querySelectorAll('.card__badge .badge:not([data-chastar-stock-badge])').forEach(badge => { badge.hidden = unavailable; });
        card.querySelectorAll('modal-opener [data-product-url]').forEach(opener => {
          const url = new URL(opener.dataset.productUrl, window.location.href);
          url.searchParams.delete('option_values');
          url.searchParams.set('variant', swatch.dataset.variantId);
          opener.dataset.productUrl = url.href;
        });
        const status = this.querySelector('[data-chastar-swatch-status]');
        if (status) status.textContent = `${this.getAttribute('aria-label')}: ${swatch.dataset.colourName}`;
      });
    }

    disconnectedCallback() {
      this.swipe?.destroy();
      this.swipe = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
